import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_ADDITIONAL_INTEREST__LIST,
  APP_FILE_ADDITIONAL_INTEREST_COMPOSER,
  APP_FILE_BRANCH_OFFICE_COMPOSER,
  APP_FILE_BRANCH_OFFICE_LIST,
  APP_FILE_BROKER_CODE_COMPOSER,
  APP_FILE_BROKER_CODE_LIST,
  APP_FILE_BROKER_CONTACT_LIST,
  APP_FILE_CSIO_COMPANY_COMPOSER,
  APP_FILE_GROUP_PLAN_LIST,
  APP_FILE_INSURER_COMPOSER,
  APP_FILE_INSURERES,
  APP_FILE_INTERESTED_PARTY_COMPOSER,
  APP_FILE_INTERESTED_PARTY_LIST,
  APP_FILE_MANAGE_BROKER_CONTACTS,
  APP_FILE_POLICY_COMMISSION_COMPOSER,
  APP_FILE_SUB_INSURER_COMPOSER,
  APP_FILE_UNDERWRITER_COMPOSER,
  APP_FILE_UNDERWRITER_LIST,
} from "./insuranceCompany.constants";
const Insurers = Loadable(
  lazy(() =>
    import("./Insurers").then(({ Insurers }) => ({
      default: Insurers,
    }))
  )
);

const InsurerComposer = Loadable(
  lazy(() =>
    import("./components/InsurerCode/InsurerComposer").then(
      ({ InsurerComposer }) => ({
        default: InsurerComposer,
      })
    )
  )
);

const CsioCompanyComposer = Loadable(
  lazy(() =>
    import("./components/CsioCompany/CsioCompanyComposer").then(
      ({ CsioCompanyComposer }) => ({
        default: CsioCompanyComposer,
      })
    )
  )
);

const SubInsurerComposer = Loadable(
  lazy(() =>
    import("./components/SubInsurer/SubInsurerComposer").then(
      ({ SubInsurerComposer }) => ({
        default: SubInsurerComposer,
      })
    )
  )
);

const PolicyCommissionComposer = Loadable(
  lazy(() =>
    import("./components/PolicyCommission/PolicyCommissionComposer").then(
      ({ PolicyCommissionComposer }) => ({
        default: PolicyCommissionComposer,
      })
    )
  )
);

const UnderWritersList = Loadable(
  lazy(() =>
    import("./UnderWritersList").then(({ UnderWritersList }) => ({
      default: UnderWritersList,
    }))
  )
);

const UnderWritersComposer = Loadable(
  lazy(() =>
    import(
      "./components/UnderWriters/UnderWritersComposer"
    ).then(({ UnderWritersComposer }) => ({
      default: UnderWritersComposer,
    }))
  )
);

const BrokerCodeComposer = Loadable(
  lazy(() =>
    import(
      "./components/BrokerCode/BrokerCodeComposer"
    ).then(({ BrokerCodeComposer }) => ({
      default: BrokerCodeComposer,
    }))
  )
);

const BrokerCodeList = Loadable(
  lazy(() =>
    import("./BrokerCodeList").then(
      ({ BrokerCodeList }) => ({
        default: BrokerCodeList,
      })
    )
  )
);

const BrokerContactsList = Loadable(
  lazy(() =>
    import(
      "./components/BrokerContacts/BrokerContacts"
    ).then(({ BrokerContacts }) => ({
      default: BrokerContacts,
    }))
  )
);

const ManageBrokerContacts = Loadable(
  lazy(() =>
    import(
      "./components/BrokerContacts/ManageBrokerContact"
    ).then(({ ManageBrokerContact }) => ({
      default: ManageBrokerContact,
    }))
  )
);

const GroupPlansList = Loadable(
  lazy(() =>
    import("./GroupPlansList").then(
      ({ GroupPlansList }) => ({
        default: GroupPlansList,
      })
    )
  )
);
const GroupPlans = Loadable(
  lazy(() =>
    import("./components/GroupPlans/GroupPlans").then(
      ({ GroupPlans }) => ({
        default: GroupPlans,
      })
    )
  )
);

const BranchOfficeComposer = Loadable(
  lazy(() =>
    import(
      "./components/BranchOffice/BranchOfficeComposer"
    ).then(({ BranchOfficeComposer }) => ({
      default: BranchOfficeComposer,
    }))
  )
);

const BranchOfficeList = Loadable(
  lazy(() =>
    import("./BranchOfficeList").then(
      ({ BranchOfficeList }) => ({
        default: BranchOfficeList,
      })
    )
  )
);

const InterestedPartyList = Loadable(
  lazy(() =>
    import("./InterestedPartyList").then(
      ({ InterestedPartyList }) => ({
        default: InterestedPartyList,
      })
    )
  )
);

const InterestedPartyComposer = Loadable(
  lazy(() =>
    import(
      "./components/InterestedParty/InterestedParty"
    ).then(({ InterestedParty }) => ({
      default: InterestedParty,
    }))
  )
);

const AdditionalInterestList = Loadable(
  lazy(() =>
    import("./AdditionalInteretList").then(
      ({ AdditionalInterestList }) => ({
        default: AdditionalInterestList,
      })
    )
  )
);

const AdditionalInterestComposer = Loadable(
  lazy(() =>
    import(
      "./components/AdditionalInterest/AdditionalInterest"
    ).then(({ AdditionalInterest }) => ({
      default: AdditionalInterest,
    }))
  )
);
export const insuranceCompanyRoutes = [
  {
    path: `${APP_FILE_INSURERES}`,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleKeys={[
          MODULE_IDS.INSURER,
          MODULE_IDS.CSIO_COMPANY,
          MODULE_IDS.INSURER_SUB,
          MODULE_IDS.POLICY_COMISSION,
        ]}
      >
        <Insurers />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_INSURERES}/:type`,
    exact: true,
    element: (
      <AuthorizedRoute
        moduleKeys={[
          MODULE_IDS.INSURER,
          MODULE_IDS.CSIO_COMPANY,
          MODULE_IDS.INSURER_SUB,
          MODULE_IDS.POLICY_COMISSION,
        ]}
      >
        <Insurers />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_INSURER_COMPOSER}`,

    children: [
      {
        path: `${APP_FILE_INSURER_COMPOSER}/`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER]}>
            <InsurerComposer />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_INSURER_COMPOSER}/:id`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER]}>
            <InsurerComposer />
          </AuthorizedRoute>
        ),
      },
    ],
  },
  {
    path: `${APP_FILE_CSIO_COMPANY_COMPOSER}`,
    children: [
      {
        path: `${APP_FILE_CSIO_COMPANY_COMPOSER}/`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_COMPANY]}>
            <CsioCompanyComposer />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_CSIO_COMPANY_COMPOSER}/:id`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_COMPANY]}>
            <CsioCompanyComposer />
          </AuthorizedRoute>
        ),
      },
    ],
  },
  {
    path: `${APP_FILE_SUB_INSURER_COMPOSER}`,
    children: [
      {
        path: `${APP_FILE_SUB_INSURER_COMPOSER}/`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_SUB]}>
            <SubInsurerComposer />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_SUB_INSURER_COMPOSER}/:id`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.INSURER_SUB]}>
            <SubInsurerComposer />
          </AuthorizedRoute>
        ),
      },
    ],
  },
  {
    path: `${APP_FILE_POLICY_COMMISSION_COMPOSER}`,
    children: [
      {
        path: `${APP_FILE_POLICY_COMMISSION_COMPOSER}/`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.POLICY_COMISSION]}>
            <PolicyCommissionComposer />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_POLICY_COMMISSION_COMPOSER}/:id`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.POLICY_COMISSION]}>
            <PolicyCommissionComposer />
          </AuthorizedRoute>
        ),
      },
    ],
  },
  {
    path: `${APP_FILE_UNDERWRITER_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.UNDERWRITERS]}>
        <UnderWritersList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_UNDERWRITER_COMPOSER}`,
    children: [
      {
        path: `${APP_FILE_UNDERWRITER_COMPOSER}/`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.UNDERWRITERS]}>
            <UnderWritersComposer />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_UNDERWRITER_COMPOSER}/:id`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.UNDERWRITERS]}>
            <UnderWritersComposer />
          </AuthorizedRoute>
        ),
      },
    ],
  },
  {
          path: `${APP_FILE_BROKER_CODE_COMPOSER}`,
          children: [
            {
              path:`${APP_FILE_BROKER_CODE_COMPOSER}/`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
                  <BrokerCodeComposer />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${APP_FILE_BROKER_CODE_COMPOSER}/:id`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
                  <BrokerCodeComposer />
                </AuthorizedRoute>
              ),
            },
          ],
        },
        {
          path: `${APP_FILE_BROKER_CODE_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
              <BrokerCodeList />
            </AuthorizedRoute>
          ),
        },
  
        {
          path: `${APP_FILE_BROKER_CONTACT_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CONTACTS]}>
              <BrokerContactsList />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_MANAGE_BROKER_CONTACTS}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CONTACTS]}>
              <ManageBrokerContacts />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_MANAGE_BROKER_CONTACTS}/:brokerContactCode`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CONTACTS]}>
              <ManageBrokerContacts />
            </AuthorizedRoute>
          ),
        },

        {
                path: `${APP_FILE_GROUP_PLAN_LIST}`,
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
                    <GroupPlansList />
                  </AuthorizedRoute>
                ),
              },
              {
                path: `${APP_FILE_GROUP_PLAN_LIST}/create`,
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
                    <GroupPlans />
                  </AuthorizedRoute>
                ),
              },
              {
                path: `${APP_FILE_GROUP_PLAN_LIST}/:planCode`,
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.BROKER_CODES]}>
                    <GroupPlans />
                  </AuthorizedRoute>
                ),
              },
              
                    {
                      path: `${APP_FILE_BRANCH_OFFICE_COMPOSER}`,
                      children: [
                        {
                          path: `${APP_FILE_BRANCH_OFFICE_COMPOSER}`,
                          exact: true,
                          element: (
                            <AuthorizedRoute moduleKeys={[MODULE_IDS.BRANCH_OFFICES]}>
                              <BranchOfficeComposer />
                            </AuthorizedRoute>
                          ),
                        },
                        {
                          path:`${APP_FILE_BRANCH_OFFICE_COMPOSER}/:id`,
                          exact: true,
                          element: (
                            <AuthorizedRoute moduleKeys={[MODULE_IDS.BRANCH_OFFICES]}>
                              <BranchOfficeComposer />
                            </AuthorizedRoute>
                          ),
                        },
                      ],
                    },
                    {
                      path:`${APP_FILE_BRANCH_OFFICE_LIST}`,
                      exact: true,
                      element: (
                        <AuthorizedRoute moduleKeys={[MODULE_IDS.BRANCH_OFFICES]}>
                          <BranchOfficeList />
                        </AuthorizedRoute>
                      ),
                    },
               {
                      path: `${APP_FILE_INTERESTED_PARTY_COMPOSER}`,
                      children: [
                        {
                          path: `${APP_FILE_INTERESTED_PARTY_COMPOSER}`,
                          exact: true,
                          element: (
                            <AuthorizedRoute moduleKeys={[MODULE_IDS.INTERESTED_PARTIES]}>
                              <InterestedPartyComposer />
                            </AuthorizedRoute>
                          ),
                        },
                        {
                          path: `${APP_FILE_INTERESTED_PARTY_COMPOSER}/:id`,
                          exact: true,
                          element: (
                            <AuthorizedRoute moduleKeys={[MODULE_IDS.INTERESTED_PARTIES]}>
                              <InterestedPartyComposer />
                            </AuthorizedRoute>
                          ),
                        },
                      ],
                    },
              
                    {
                      path: `${APP_FILE_INTERESTED_PARTY_LIST}`,
                      exact: true,
                      element: (
                        <AuthorizedRoute moduleKeys={[MODULE_IDS.INTERESTED_PARTIES]}>
                          <InterestedPartyList />
                        </AuthorizedRoute>
                      ),
                    },
        
              {
                path:`${APP_FILE_ADDITIONAL_INTEREST_COMPOSER}`,
                children: [
                  {
                    path: `${APP_FILE_ADDITIONAL_INTEREST_COMPOSER}`,
                    exact: true,
                    element: (
                      <AuthorizedRoute moduleKeys={[MODULE_IDS.ADDITIONAL_INTERESTS]}>
                        <AdditionalInterestComposer />
                      </AuthorizedRoute>
                    ),
                  },
                  {
                    path: `${APP_FILE_ADDITIONAL_INTEREST_COMPOSER}/:id`,
                    exact: true,
                    element: (
                      <AuthorizedRoute moduleKeys={[MODULE_IDS.ADDITIONAL_INTERESTS]}>
                        <AdditionalInterestComposer />
                      </AuthorizedRoute>
                    ),
                  },
                ],
              },
              {
                path: `${APP_FILE_ADDITIONAL_INTEREST__LIST}`,
                exact: true,
                element: (
                  <AuthorizedRoute moduleKeys={[MODULE_IDS.ADDITIONAL_INTERESTS]}>
                    <AdditionalInterestList />
                  </AuthorizedRoute>
                ),
              },
             
];
